import { render, staticRenderFns } from "./StaticPagination.vue?vue&type=template&id=4bb45e50&"
import script from "./StaticPagination.vue?vue&type=script&lang=ts&"
export * from "./StaticPagination.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports